import giphy from "../images/giphy.gif";
export const Loading = () => {
  return (
    <section>
      <img src={giphy} alt="loading" />
    </section>
  );
};
